/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Content_TitleInputs */



/**
* | output |
* | --- |
* | "Content" |
*
* @param {Options_Watermark_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_content_title = /** @type {((inputs?: Options_Watermark_Content_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Content_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Содержимое")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("内容")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conteúdo")
	return /** @type {LocalizedString} */ ("Content")
});